import { rankWith, schemaTypeIs } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import { useTranslation } from "react-i18next";
import SFTextField from "../../textField";
import SFTypography from "../../typography";

const TextFieldRenderer = ({
  data,
  handleChange,
  path,
  uischema,
  required,
  enabled,
  errors,
  // Added to allow toggling of text fields depending on the value of Checkbox. We need to enable this for other fields when required
  visible,
}) => {
  // Need to check if this breaks the validation
  if (!visible) return null;

  const { t } = useTranslation();
  const { i18nKey, label, options } = uischema;
  const isMultiline =
    typeof options?.rows !== "undefined" || options?.multi === true;
  const onChange = (e) => {
    const text = e.target.value;
    if (text.trim() === "") {
      return handleChange(path, undefined);
    }
    handleChange(path, text);
  };

  return (
    <div>
      <SFTextField
        label={i18nKey ? t(i18nKey) : label}
        value={data ? data : ""}
        variant="filled"
        disabled={options?.readonly || !enabled}
        readOnly={options?.readonly}
        multiline={isMultiline}
        rows={options?.rows}
        maxRows={options?.rows ? null : options?.maxRows ?? 2}
        required={required}
        onChange={onChange}
        errors={errors}
        hasHtml={options?.hasHtml}
        maxLength={options?.maxLength}
        textIcon={options?.customIcon}
        isCopilotField={options?.isCopilotField}
        {...options?.onBlur && ({onBlur: (e) => options.onBlur(e)})}
        {...options?.onKeyDown && ({onKeyDown: (e) => options.onKeyDown(e)})}
      />
      {options?.helperText && (
        <SFTypography variant="tableList" align="left">{t(options?.helperText)}</SFTypography>
      )}
    </div>
  );
};

export const TextFieldTester = rankWith(100, schemaTypeIs("string"));

export default withJsonFormsControlProps(TextFieldRenderer);
